import {APIURLLEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fetchConceptos() {
    const url=APIURLLEGALES + "/pagossinfactura/listarConceptos"
    const response = apiClient.get(url)
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter;